<template>
  <div>
    <div class="choose-product-wrapper">
      <div
        class="arrow arrow-left"
        @click="scrollLeft()"
        :class="{ 'arrow-enabled': canScrollLeft }"
      >
        <icon-chevron-left />
      </div>
      <div
        class="arrow arrow-right"
        @click="scrollRight()"
        :class="{ 'arrow-enabled': canScrollRight }"
      >
        <icon-chevron-left />
      </div>
      <ul class="ul-selectable-products margin-bottom-x1 disable-user-select">
        <li
          v-for="x in sortedProducts"
          :key="x.id"
          @click="() => (preselected !== x.id ? $emit('input', x.id) : null)"
          :class="
            preselected === x.id
              ? 'preselected'
              : value === x.id
              ? 'selected'
              : ''
          "
          :id="`product-${x.id}`"
        >
          <p class="header">{{ __(x.name) }}</p>
          <p class="sub-header">
            <span>{{
              `${__('från')} ${Math.round(
                x.prices[availableSubscriptions.length - 1] /
                  availableSubscriptions[availableSubscriptions.length - 1]
              )} ${__('kr')}`
            }}</span>
            {{ __('/månad') }}
          </p>
          <ul>
            <li>
              <icon-checkmark />
              {{ __('Rita upp din hage') }}
            </li>
            <li>
              <icon-checkmark />
              {{ `${__('Inlogg till')} ${x.login} ${__('st enheter')}` }}
            </li>
            <li :class="x.sensors ? '' : 'opacity'">
              <icon-checkmark v-if="x.sensors" />
              <icon-delete v-else />
              {{ `${x.sensors || 5} ${__('st sensorer')}` }}
            </li>
            <li :class="x.share ? '' : 'opacity'">
              <icon-checkmark v-if="x.share" />
              <icon-delete v-else />
              {{ __('Dela din hage med andra') }}
            </li>
            <li :class="x.service ? '' : 'opacity'">
              <icon-checkmark v-if="x.service" />
              <icon-delete v-else />
              {{ __('Personlig service') }}
            </li>
          </ul>
          <div v-if="preselected === x.id" class="preselected">
            <p>{{ __('Nuvarande abonnemang') }}</p>
          </div>
          <button
            :disabled="preselected === x.id"
            class="button button-snd mobile"
            @click="
              () => {
                $emit('input', x.id)
                next()
              }
            "
          >
            {{ __('Välj') }}
          </button>
        </li>
      </ul>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  data () {
    return {
      canScrollLeft: false,
      canScrollRight: true,
      sortedProducts: [],
    }
  },
  props: ['value', 'next', 'preselected'],
  components: {
    IconCheckmark: () => import('@/components/icons/IconCheckmark.vue'),
    IconDelete: () => import('@/components/icons/IconDelete.vue'),
    IconChevronLeft: () => import('@/components/icons/IconChevronLeft.vue'),
  },
  computed: {
    availableProducts () {
      return this.$store.getters.availableProducts
    },
    availableSubscriptions () {
      return this.$store.getters.availableSubscriptions
    },
  },
  mounted () {
    this.sortedProducts = []
    const products = []
    const keys = Object.keys(this.availableProducts)
    keys.forEach((key) => {
      products.push(this.availableProducts[key])
    })
    products.sort((a, b) => (a.order > b.order ? 1 : -1))
    this.sortedProducts = products
  },
  methods: {
    scrollLeft () {
      let content = document.querySelector('.ul-selectable-products')
      if (content.scrollLeft) {
        content.scrollLeft -= 300
        this.canScrollLeft = content.scrollLeft - 300 > 0
        this.canScrollRight = true
      }
    },
    scrollRight () {
      let content = document.querySelector('.ul-selectable-products')
      if (content.clientWidth + content.scrollLeft < content.scrollWidth) {
        content.scrollLeft += 300
        this.canScrollRight =
          content.clientWidth + content.scrollLeft + 300 < content.scrollWidth
        this.canScrollLeft = true
      }
    },
  },
}
</script>
<style lang="less">
@import '../style/variables.less';
.choose-product-wrapper {
  width: 100%;
  justify-content: center;
  display: flex;
  position: relative;
  .arrow {
    display: none;
  }
}
.ul-selectable-products {
  scroll-behavior: smooth;
  text-align: left;
  display: flex;
  flex-direction: column;
  list-style: none;
  align-items: center;
  > li {
    border: 2px solid transparent;
    position: relative;
    cursor: pointer;
    flex-direction: column;
    background: @color-grey;
    color: white;
    padding: 1.4rem;
    padding-top: 2rem;
    margin-bottom: 2em;
    width: 300px;
    max-width: 80vw;

    .header {
      margin-bottom: 0.1em;
    }
    .sub-header {
      color: @color-orange;
      font-family: Oswald;
      margin-bottom: 0.8em;
      span {
        font-size: 1.4em;
        font-weight: 500;
      }
    }
    button {
      margin-bottom: 0;
      margin-top: 1em;
    }
    div.preselected {
      position: absolute;
      bottom: -20px;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      p {
        background: @color-orange;
        padding: 7px 10px;
        font-family: Oswald;
        color: @color-grey;
        font-size: 0.8rem;
        text-transform: uppercase;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      li {
        display: flex;
        align-items: center;
        font-size: 0.8rem;
        line-height: 2em;
        .icon {
          width: 0.7em;
          margin-right: 1em;
        }
      }
    }
  }
  li.preselected {
    border-bottom-color: @color-orange !important;
  }
}
@media (min-width: @width-device-md) {
  .choose-product-wrapper {
    .arrow {
      display: flex;
      align-items: center;
      position: absolute;
      height: 85%;
      color: @color-grey-light;
      cursor: pointer;
      .icon {
        width: 3em;
        height: 3em;
      }
    }
    .arrow-left {
      left: -4em;
    }
    .arrow-right {
      right: -4em;
      transform: rotate(180deg);
    }
    .arrow-enabled {
      animation: pulse 1s infinite alternate;
    }
    @keyframes pulse {
      from {
        color: white;
        //box-shadow: 0px 0px 5px #fff;
      }
      to {
        color: @color-grey-light;
        //box-shadow: 0px 0px 15px #fff;
      }
    }
    .arrow-enabled:hover {
      animation-play-state: paused;
      color: white !important;
    }
  }
  .ul-selectable-products {
    width: calc(
      @width-card-md - 14em
    ); // width of card minus a bit more than twice the arrow size
    max-width: 80vw;
    flex-direction: row;
    overflow-x: hidden;
    padding: 20px 0;
    > li {
      flex-shrink: 0;
      width: 240px;
      button {
        display: none;
      }
    }
    > li:not(:last-child) {
      margin-right: 1.5em;
    }
  }
  li.selected {
    border-color: @color-orange !important;
  }
}
</style>
